"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var PlacesAutocomplete_1 = __importDefault(require("../../../PlacesAutocomplete/PlacesAutocomplete"));
var react_i18next_1 = require("react-i18next");
var api_1 = require("@react-google-maps/api");
var react_redux_1 = require("react-redux");
var GoogleGeocoding_1 = __importDefault(require("../../../../constants/GoogleGeocoding"));
var i18n_1 = __importDefault(require("../../../../i18n"));
var Button_1 = __importDefault(require("../../../Button"));
var banali_react_leaflet_1 = require("banali-react-leaflet");
var leaflet_1 = __importDefault(require("leaflet"));
var Choropleth_1 = __importDefault(require("../Choropleth"));
var addressGeometries_1 = require("../../../../helpers/addressGeometries");
var mapHelpers_1 = require("../../../../helpers/mapHelpers");
var SaveButtons_1 = __importDefault(require("./GoogleWrapper/SaveButtons"));
var useTileLayer_1 = require("../../../../hooks/useTileLayer");
var languageSlice_1 = require("../../../../features/languages/languageSlice");
var classnames_1 = __importDefault(require("classnames"));
require("leaflet/dist/leaflet.css");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var icon = leaflet_1.default.icon({
    iconSize: [25, 41],
    iconAnchor: [10, 41],
    popupAnchor: [2, -40],
    iconUrl: 'https://unpkg.com/leaflet@1.6/dist/images/marker-icon.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.6/dist/images/marker-shadow.png',
});
var AddressAutocomplete = function (_a) {
    var addressData = _a.addressData, currentLocation = _a.currentLocation, handleChangeCurrentLocation = _a.handleChangeCurrentLocation, isDistrictCompleted = _a.isDistrictCompleted, handleSaveAddressData = _a.handleSaveAddressData, handleClearAddress = _a.handleClearAddress, polygon = _a.polygon, selectedDistrict = _a.selectedDistrict, selectedDistrictCenter = _a.selectedDistrictCenter, resetAddressValue = _a.resetAddressValue;
    var t = react_i18next_1.useTranslation('common').t;
    var isLoaded = api_1.useJsApiLoader({
        googleMapsApiKey: GoogleGeocoding_1.default.API_KEY,
        libraries: GoogleGeocoding_1.default.MAP_LIBS,
        language: i18n_1.default.language,
    }).isLoaded;
    var currentLanguage = react_redux_1.useSelector(languageSlice_1.selectCurrentLanguage);
    var tileLayer = useTileLayer_1.useTileLayer(currentLanguage);
    var _b = react_1.useState(false), isSubmitted = _b[0], setIsSubmitted = _b[1];
    var _c = react_1.useState(false), isActiveMap = _c[0], setIsActiveMap = _c[1];
    var _d = react_1.useState(currentLocation), marker = _d[0], setMarker = _d[1];
    var _e = react_1.useState(), currentMouseLatLnt = _e[0], setCurrentMouseLatLng = _e[1];
    var _f = react_1.useState(), mapInitialCenter = _f[0], setMapInitialCenter = _f[1];
    react_1.useEffect(function () {
        !isSubmitted && setIsActiveMap(isSubmitted);
    }, [isSubmitted]);
    react_1.useEffect(function () {
        setIsSubmitted(false);
    }, [addressData]);
    react_1.useEffect(function () {
        if ((currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.lat) && (currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.lng)) {
            setMarker(currentLocation);
        }
        else {
            setMarker(GoogleGeocoding_1.default.MAP.DEFAULT_CENTER);
        }
    }, [currentLocation]);
    react_1.useEffect(function () {
        if (currentMouseLatLnt && polygon && isActiveMap) {
            addressGeometries_1.getIsContainsLocation(addressGeometries_1.convertCoordinatesToLatLng(polygon), currentMouseLatLnt) && setMarker(currentMouseLatLnt);
        }
    }, [currentMouseLatLnt, polygon]);
    react_1.useEffect(function () {
        if ((currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.lat) && (currentLocation === null || currentLocation === void 0 ? void 0 : currentLocation.lng)) {
            setMapInitialCenter(currentLocation);
        }
        else {
            setMapInitialCenter(GoogleGeocoding_1.default.MAP.DEFAULT_CENTER);
        }
    }, [currentLocation]);
    var handleChangeAddress = function (place) {
        if (place) {
            handleChangeCurrentLocation({
                lat: place.center.lat,
                lng: place.center.lng,
            }, mapHelpers_1.formatAddress(place.main_text));
        }
    };
    var handleSubmit = function () {
        setIsSubmitted(true);
        handleSaveAddressData(currentLocation);
    };
    var catchWhenValueIsEmpty = function () {
        resetAddressValue();
        setIsSubmitted(false);
    };
    var handleActivateMap = function (event) {
        event.preventDefault();
        var _a = selectedDistrictCenter, lat = _a[0], lng = _a[1];
        setMapInitialCenter({ lat: Number(lat), lng: Number(lng) });
        setIsActiveMap(true);
    };
    var handleSave = function () {
        setIsActiveMap(false);
        handleSaveAddressData(marker);
    };
    var handleCancel = function () {
        setIsActiveMap(false);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.bl_place_autocomplete },
            isLoaded && (react_1.default.createElement("div", { className: styles_module_scss_1.default.search_input },
                react_1.default.createElement("div", { className: classnames_1.default('field required', styles_module_scss_1.default.search_label) },
                    react_1.default.createElement("label", null, t('ADDRESS_PICKER.ADDRESS'))),
                react_1.default.createElement(PlacesAutocomplete_1.default, { initialValue: addressData.address, placeholderText: t('ADDRESS_PICKER.CHOOSE_ADDRESS'), isDisabled: !isDistrictCompleted, addressPickerSelection: handleChangeAddress, catchWhenValueIsEmpty: catchWhenValueIsEmpty, onClearAddress: handleClearAddress, popoverClassName: "address-picker" }))),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.submit_button },
                react_1.default.createElement(Button_1.default, { type: "button", variant: "primary", onClick: handleSubmit, disabled: isSubmitted ||
                        !addressData.address ||
                        !selectedDistrict }, t('ADDRESS_PICKER.DONE')))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.map_container },
            react_1.default.createElement(banali_react_leaflet_1.MapContainer, { style: { height: '100vh' }, zoomControl: false, whenReady: function (map) {
                    map.target.on('click', function (e) {
                        setCurrentMouseLatLng(e.latlng);
                    });
                }, attributionControl: false },
                react_1.default.createElement(banali_react_leaflet_1.TileLayer, { url: tileLayer }),
                react_1.default.createElement(Choropleth_1.default, { polygon: polygon, isActiveMap: isActiveMap, mapInitialCenter: mapInitialCenter, isSubmitted: isSubmitted }),
                !!polygon && react_1.default.createElement(banali_react_leaflet_1.Marker, { position: marker, icon: icon })),
            react_1.default.createElement(SaveButtons_1.default, { isActiveMap: isActiveMap, isSubmitted: isSubmitted, handleActivateMap: handleActivateMap, handleSave: handleSave, handleCancel: handleCancel }))));
};
exports.default = AddressAutocomplete;
